<app-nav-bar></app-nav-bar>
<div class="main-content">
    <router-outlet />
</div>
